import { useEffect, useMemo, useRef } from 'react'
import { useBraze } from '~/hooks'
import { Braze } from '~/lib'
import { BrazeBannerProps } from './BrazeBanner.types'

export const BrazeBanner = ({ placementId }: BrazeBannerProps) => {
  const { banners } = useBraze()
  const containerRef = useRef<HTMLDivElement>()

  const banner = useMemo(() => {
    return banners[placementId]
  }, [banners, placementId])

  /* const { containerRef, banner } = useBrazeBanner(placementId) */

  useEffect(() => {
    if (!banner?.id || containerRef.current == null) {
      return
    }

    Braze.renderBanner(banner, containerRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banner?.id])

  return <div ref={containerRef} />
}
